<script>
	import { topNavigationVisible, topNavigationWidth } from '../share/stores';
	import { onMount } from 'svelte';

	import TopNavigationFooter from '../components/TopNavigationFooter.svelte';
	import NavListElement from '../helpers/NavListElement.svelte';

	let navDiv;

	let portfolioSubMenuOpened = false;

	function openSubMenu(node, isOpen) {
		let initialHeight = node.offsetHeight;
		node.style.height = isOpen ? 'auto' : 0;
		node.style.overflow = "hidden";
		return {
			update(isOpen) {
				let animation = node.animate(
						[
							{
								height: initialHeight + 'px',
								overflow: 'hidden'
							},
							{
								height: 0,
								overflow: 'hidden'
							}
						],
						{ duration: 100, fill: 'both' }
				);
				animation.pause();
				if (!isOpen) {
					animation.play();
				} else {
					animation.reverse();
				}
			}
		};
	}

	function setTopNavigationWidth() {
		if(window.getComputedStyle(navDiv, null).display !== 'none') {
			topNavigationWidth.set(navDiv.getBoundingClientRect().width);
		}
		requestAnimationFrame(setTopNavigationWidth);
	}

	onMount(() => {
		setTopNavigationWidth();
		window.addEventListener('animatedPagesDone', () => portfolioSubMenuOpened = false);
	});
</script>


<div bind:this={navDiv} class:opened={$topNavigationVisible}>
	<nav>
		<ul>
			<NavListElement url="agentur" text="Agentur"/>
			<NavListElement url="expertise_design" text="Expertise // Design"/>
			<NavListElement url="expertise_technologie" text="Expertise // Technologie"/>
			<li>
				<NavListElement url="portfolio" text="Portfolio"/>
				<button aria-label="open Portfolio SubMenu" class="portfolioSubMenu" class:opened={portfolioSubMenuOpened}
						on:click|stopPropagation={() => portfolioSubMenuOpened = !portfolioSubMenuOpened}></button>
				<ul use:openSubMenu={portfolioSubMenuOpened}>
					<NavListElement url="portfolio/appetit_digitalisieren" text="Appetit digitalisieren"/>
					<NavListElement url="portfolio/ueberflieger" text="Überflieger"/>
					<NavListElement url="portfolio/menschen_bewegen" text="Menschen bewegen"/>
					<NavListElement url="portfolio/stream_on" text="Stream On"/>
					<NavListElement url="portfolio/weltweit_regional" text="weltweit regional"/>
					<NavListElement url="portfolio/kein_mittelmass" text="Kein Mittelmaß"/>
					<NavListElement url="portfolio/individuelle_klasse" text="individuell(e) Klasse"/>
					<NavListElement url="portfolio/health_and_care" text="Health & Care"/>
					<NavListElement url="portfolio/burgeins_stromert" text="BurgEins stromert"/>
					<NavListElement url="portfolio/opel_case_study" text="Opel Case Study"/>
				</ul>
			</li>
		</ul>

		<ul>
			<NavListElement url="agentur/jobs" text="Jobs"/>
			<NavListElement url="agentur/kontakt" text="Kontakt"/>
			<NavListElement url="datenschutz" text="Datenschutz"/>
			<NavListElement url="impressum" text="Impressum"/>
		</ul>
	</nav>

	<TopNavigationFooter/>
</div>

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";

	div {
		order: 1;
		display: block;
		position: relative;
		width: 0;
		background-color: black;
		font-weight: 300;
		color: white;
		z-index: 100;
		// 4em = TopNavigation ".container" height
		// $spacing-mobile-one-third = BreadCrumb Padding top and bottom
		// 2.2rem = BreadCrumb "li a" line-height
		height: calc(100vh - px-to-em(64) - ($spacing-mobile-one-third * 2) - 2.2rem);
		overflow-y: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: space-between;

		&.opened {
			width: min-content;
		}

		@include for-tablet-landscape-up {
			display: none; /* todo: hide LeftNavigation for-tablet-landscape-up */
		}

		nav {
			display: flex;
			padding: 3em 3em 0 3em;
			flex-flow: column nowrap;
			justify-content: flex-start;
			flex: 1;

			ul {
				list-style: none;
				flex-direction: column;
				align-items: stretch;

				&:nth-of-type(2) {
					color: rgba(255, 255, 255, 0.65);
					margin-top: $spacing-mobile;
				}

				:global(li) {
					text-align: left;
					white-space: nowrap;
					margin-bottom: 1.5em;
					position: relative;
				}

				:global(li a) {
					font-size: 2.2rem;
					line-height: 3rem;
				}

				:global(li button) {
					position: absolute;
					right: 0;
					top: 0;
					z-index: 10;
					background: transparent;
					border: 0;
					cursor: pointer;
				}

				:global(li button::before) {
					content: '';
					position: relative;
					display: block;
					padding: 5px;
					height: 0px;
					line-height: 0;
					border: solid #dedede;
					border-width: 0 3px 3px 0;
					transition: transform .2s ease-in-out;
					transform: rotate(45deg);
				}

				:global(li button.opened::before) {
					transform: rotate(225deg);
				}

				:global(li ul li) {
					margin-bottom: 0;
					margin-left: 1.5em;
				}

				:global(a) {
					text-decoration: none;
				}

				:global(.active) {
					color: white !important;
				}
			}

			> ul:first-of-type {
				:global(> li > div > a) {
					font-weight: 600;
				}
				:global(> li > li > div > a) {
					font-weight: 600;
				}
			}
		}
	}
</style>
